module.exports = __webpack_public_path__ + "img/carryingValueOrange.6f03b902.png";